import { render, staticRenderFns } from "./RequiredCurriculumView.vue?vue&type=template&id=7344316c&scoped=true"
import script from "./RequiredCurriculumView.vue?vue&type=script&lang=js"
export * from "./RequiredCurriculumView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7344316c",
  null
  
)

export default component.exports